import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import { Page } from '../../../components';
import { homeownerPortalTheme } from '../styles/homeowner-portal-theme';
import { HomeownerFooter } from './homeowner-footer';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

interface HomeownerPortalWrapperProps {
  children: React.ReactNode;
  title?: string;
}

export const HomeownerPortalWrapper: React.FC<HomeownerPortalWrapperProps> = ({
  children,
  title = 'Homeowner Portal'
}) => {
  const location = useLocation();

  // Scroll to top when route changes within homeowner portal
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <Page
      title={title === 'Homeowner Portal' ? title : `Homeowner Portal | ${title}`}
      showSideNav={false}
      showBreadcrumbs={false}
      hasNoContentPadding={true}
      showFooter={false}
    >
      <ThemeProvider theme={homeownerPortalTheme}>
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          {children}
          <HomeownerFooter />
        </Box>
      </ThemeProvider>
    </Page>
  );
};
